export class UserSearchModel {
	public page: number  = 1;
	public limit: number = 10;
	public fullname: string;
	public email: string;
	public status: number;
	public agent_id: number;
	public list_role_name: any;
}
